import { Heading, Text, View } from "@instructure/ui";

const Signout = () => {
  return (
    <View>
      <Heading as="h1" margin="0 0 medium 0">
        Signed Out
      </Heading>
      <Text size="medium">
        You have been signed out. You may now close this tab to return back to
        Canvas.
      </Text>
    </View>
  );
};

export default Signout;
